import React, {FC} from 'react';
import Map, {GeolocateControl, MapProps, MapRef, NavigationControl} from 'react-map-gl';
import {ControlPosition} from 'react-map-gl/src/types/external';
import classNames from 'classnames';

import {MAP_STYLE, MAPBOX_TOKEN} from './constants';
import Marker, {MarkerProps} from './Marker';
export type {MarkerProps} from './Marker';

import 'mapbox-gl/dist/mapbox-gl.css';
import './index.scss';
import * as styles from './styles.module.scss';

type BaseMapProps = MapProps & {
	className?: string
	markers?: MarkerProps[]

	mapRef: React.Ref<MapRef>
	controls?: {
		nav?: true | {
			position?: ControlPosition
		}
		geo?: boolean
	}
}

// We want a ref passed into BaseMap to be forwarded to the actual map
export const BaseMap: FC<BaseMapProps> = (props) => {
	const {
		className,
		markers,

		controls,

		// Remove some variables that throw TypeScript errors
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		fog, terrain,

		// Ref we're threading through
		mapRef,

		...rest
	} = props;

	const mapProps = {
		mapStyle: MAP_STYLE,
		mapboxAccessToken: MAPBOX_TOKEN,
		ref: mapRef,
		...rest,
	};

	return (
		<div className={classNames(styles.map, className)}>
			<Map {...mapProps}>
				{controls?.nav && (
					<NavigationControl
						showCompass={false}
						position={
							controls.nav === true ?
								undefined :
								controls.nav.position
						}
					/>
				)}
				{controls?.geo && (
					<GeolocateControl />
				)}
				{(markers || []).map((props) => (
					<Marker {...props} key={props.id} />
				))}
			</Map>
		</div>
	);
};
